import Icon from '../components/Icon.vue'

Icon.register({
  'angle-double-right': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9l22.5-22.8c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6 0.1 34zM416.3 239c9.4 9.4 9.4 24.6 0 33.8l-136 136c-9.3 9.4-24.5 9.4-33.9 0l-22.6-22.6c-9.4-9.3-9.4-24.5 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.3-9.4-24.5 0-33.9l22.6-22.6c9.3-9.4 24.5-9.4 33.9 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-double-right.js
// module id = 604
// module chunks = 0